import { useState } from "react";

type DimensionKey = string;
type DimensionAttributeValue = string | number;

export type Dimension = [DimensionKey, DimensionAttributeValue[]?];
export type DimensionPath = Dimension[];

export type Dimensions = DimensionPath[];

export type DimensionsState = {
    setDimensions: (dimensions: Dimensions | undefined) => void;
};

type DimensionsParams = {
    query: Dimensions | undefined;
    state: DimensionsState;
};
export const useDimensions = (initDimensions?: Dimensions): DimensionsParams => {
    const [dimensions, setDimensions] = useState<Dimensions | undefined>(initDimensions);

    return {
        query: dimensions,
        state: {
            setDimensions,
        },
    };
};
